import type { CSSProperties, RefObject } from "react";
import { isPlatformNodeJS } from "../utils/platform.is-node";


/**
 * apply the given set of CSS declarations as inline style on the given element
 * (falling back to the root element)
 */
export function applyCssDeclarations(
  rules: CSSProperties,
  element?: RefObject<HTMLElement | null> | HTMLElement,
) {
  const target =
    (element && "current" in element ? element.current : element) ??
    (!isPlatformNodeJS()
      ? ((document.querySelector(":root") as HTMLElement) ??
        document.documentElement)
      : undefined);

  if (!target) {
    return;
  }

  for (const [property, value] of Object.entries(rules)) {
    target.style.setProperty(property, value);
  }
}
